﻿import { IPosition } from './position';

export interface ICluster {
    id: number,
    clusterNumber: number,
    note: string,
    logisticsDateTime: string,
    kickoffDateTime: string,
    clusterStatusId: number,
    clusterStatus: string,
    chainStatusId: number,
    swapManager: string,
    conferenceNumber: string,
    courierVendor: number,
    courierVendorName: string,
    chainId: number,
    isFinalCluster: boolean,
    donationType: string,
    swapType: string,
    isDataComplete: boolean,
    sortOrder: number,
    positions: IPosition[],
}
